import { Action,  State, StateContext } from "@ngxs/store";
import { UpdateStudyAreaAccess } from './study-area.actions';
import { catchError, of, tap } from "rxjs";
import { StudyAreaAccessService } from "src/app/predictor/services/study-area-access.service";
import { NotificationsActions } from "../notifications/notifications.actions";
import { Severity } from "src/app/global/enums/severity";
import { StudyAreaAccess } from "src/app/predictor/enums/study-area-access";
import { Injectable } from "@angular/core";
import { PredictorModelActions } from "../predictor-model/predictor-model.actions";

export interface StudyAreaStateModel { 
}
const stateDefaults: StudyAreaStateModel = {
 sharedStudyArea: {
  email: '',
   studyAreaName: '',
   access: StudyAreaAccess.Private
 }
};

@State<StudyAreaStateModel>({
  name: 'StudyAreaState',
  defaults: stateDefaults,
})
@Injectable()
export class StudyAreaState {
  constructor(private readonly studyareaaccessservice: StudyAreaAccessService) {}

@Action(UpdateStudyAreaAccess)
updateStudyAreaAccess(
  ctx: StateContext<StudyAreaStateModel>,
  action: UpdateStudyAreaAccess
) {
  return this.studyareaaccessservice.updateAccess(action.shareStudyAreaRequest).pipe(
    tap(() => {

        ctx.dispatch(
            new NotificationsActions.Toast(
                `Study area '${action.shareStudyAreaRequest.studyAreaName}' is now ${action.shareStudyAreaRequest.isShared ? 'shared' : 'private'}.`,
                Severity.Success
            )
        );
        ctx.dispatch(new PredictorModelActions.GetStudyAreas());

    }),
    catchError((error) => {
        ctx.dispatch(
            new NotificationsActions.Toast(
                `Failed to update study area access.`,
                Severity.Error
            )
        );
        return of(error);
    })
  );
}

}
